import { render } from "./GetTipsStart.vue?vue&type=template&id=ce51edf4"
import script from "./GetTipsStart.vue?vue&type=script&lang=js"
export * from "./GetTipsStart.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__